"use strict";
exports.__esModule = true;
exports.isNotAValidUrl = void 0;
exports.isNotAValidUrl = function (url) {
    var pattern = new RegExp('^https?:\\/\\/');
    return !pattern.test(url);
};
